























import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import useMyGarage from '@shared/composables/useMyGarage';
import { GarageVehicle } from '@shared/composables/useMyGarage/types';
import { UCButton, UCIcon, UCRadio } from '@shared/ui';

import { FITMENT } from '~/constants';

export default defineComponent({
  name: 'VehiclesList',
  components: { UCRadio, UCIcon, UCButton },
  props: {
    vehicles: {
      type: Array as PropType<GarageVehicle[]>,
      default: undefined,
    },
    selectedVehicle: {
      type: Object as PropType<GarageVehicle>,
      default: undefined,
    },
    canRemove: {
      type: Boolean,
      default: false,
    },
    density: {
      type: String as PropType<'compact' | 'tiny' | 'default'>,
      default: 'default',
    },
  },
  setup(props, { emit }) {
    const { getFormattedTitleFull } = useMyGarage();

    const sortedVehicles = computed(() =>
      props.vehicles?.slice().sort((a, b) => (a?.yearFrom ?? 0) - (b?.yearFrom ?? 0)),
    );

    const isSelected = (vehicle: GarageVehicle) =>
      props.selectedVehicle?.vehicleId === vehicle.vehicleId;

    const onRadioClicked = (vehicleId: number) => {
      emit(
        'on-change',
        props.vehicles.find((v) => v.vehicleId === vehicleId),
      );
    };

    const onRemoveClicked = (vehicle: GarageVehicle) => {
      emit('on-remove', vehicle);
    };

    return {
      FITMENT,
      sortedVehicles,
      isSelected,
      getFormattedTitleFull,
      onRadioClicked,
      onRemoveClicked,
    };
  },
});
